module.exports = __webpack_public_path__ + "static/media/5_werwirsind.2f545ecf.jpg";